module.exports = __webpack_public_path__ + "img/icon_teachvideo.cc5d5536.png";